// Thin wrappers around @microsoft/teams-js authentication.authenticate().
// MSAL's own popup/redirect flows are blocked by Teams' iframe sandbox; the
// Teams SDK's authenticate() opens a Teams-controlled popup that CAN navigate
// to external auth providers like login.microsoftonline.com.

import { authentication as teamsAuth } from '@microsoft/teams-js';

// Main-tab call: opens a Teams popup pointed at startUrl and waits for
// notifySuccess / notifyFailure from the popup.
export async function signInViaTeams(startUrl: string): Promise<string> {
  return teamsAuth.authenticate({
    url: startUrl,
    width: 600,
    height: 535,
  });
}

export function notifyTeamsSuccess(result?: string): void {
  teamsAuth.notifySuccess(result);
}

// notifyTeamsFailure was removed: in the post-redirect popup the Teams SDK
// bridge has no parent context to talk to and the call throws. Main-tab
// callers handle failures by closing the popup themselves.
